import { CancelButton } from "@/components/admin/cancel-button";
import { SaveButton } from "@/components/admin/form";

/**
 * @param saveDisabled - blocks the main submit, e.g. while a sibling section
 * (Epic EA, TASK-115's `StageActivitiesSection`) holds its own unsaved picks
 * that the main submit would otherwise silently discard.
 */
export const FormToolbar = ({
  saveDisabled = false,
}: {
  saveDisabled?: boolean;
}) => (
  <div
    role="toolbar"
    className="sticky flex pt-4 pb-4 md:pb-0 bottom-0 bg-linear-to-b from-transparent to-card to-10% flex-row justify-end gap-2"
  >
    <CancelButton />
    <SaveButton disabled={saveDisabled} />
  </div>
);
